



import React from "react";
import {
  FaDraftingCompass,
  FaCube,
  FaRulerCombined,
  FaGripLines,
  FaCalculator,
  FaCheckCircle,
  FaLightbulb,
} from "react-icons/fa";

const SkilledUniversities = () => {
  const skills = [
    { icon: <FaDraftingCompass />, text: "BIW Fixture Design Principles" },
    { icon: <FaLightbulb />, text: "Conceptual Design Techniques" },
    { icon: <FaCube />, text: "3D Finish Requirements" },
    { icon: <FaRulerCombined />, text: "2D Detailing Essentials" },
    { icon: <FaGripLines />, text: "Clamping and Positioning Mechanics" },
    { icon: <FaCalculator />, text: "Cylinder Calculation and Gripper Design" },
    { icon: <FaCheckCircle />, text: "Tool Testing and Validation Procedures" },
  ];

  return (
    <div className="container">
      <div className="row" style={{ marginTop: "77px" }}>
        <div className="col-md-12">
          <h4
            style={{
              fontWeight: "900",
              paddingBottom: "50px",
              textAlign: "center",
              fontSize: "35px",
              textTransform: "initial",
              width: "100%",
            }}
          >
            Top <span style={{ color: "orange", fontSize: "35px" }}>Skills Covered</span>
          </h4>
          <ul className="skills-grid">
            {skills.map((skill, index) => (
              <li
                key={index}
                className={`skill-item ${index === 6 ? "centered" : ""}`}
              >
                <div className="skill-icon">{skill.icon}</div>
                <p className="skill-text">{skill.text}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <style>
        {`
    .skills-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr); /* Default: three columns */
      gap: 20px;
      list-style: none;
      padding: 0;
      margin: 0;
    }

    .skill-item {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding: 20px;
      background-color: #f5f5f5;
      border: 2px solid #ffc107;
      border-radius: 15px;
      text-align: center;
      transition: transform 0.3s ease, box-shadow 0.3s ease;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    }

    .skill-item:hover {
      transform: scale(1.05);
      box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
      border-top: 7px solid orange;
      border-right: 4px solid orange;
    }

    .skill-icon {
      font-size: 30px;
      color: #164485;
      margin-bottom: 10px;
    }

    .skill-text {
      font-size: 16px;
      font-family: 'Roboto', sans-serif;
      color: #333;
    }

    /* Center the last item in the last row */
    .centered {
      grid-column: 2 / 3; /* Place the last container in the middle column */
    }

    /* Responsive for tablet view */
    @media (max-width: 768px) {
      .skills-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 15px;
      }
      .centered {
        grid-column: 1 / 3; /* Center the container across two columns */
      }
      .skill-text {
        font-size: 14px;
      }
    }

    /* Responsive for mobile view */
    @media (max-width: 576px) {
      .skills-grid {
        grid-template-columns: 1fr; /* Single column for mobile view */
      }
      .centered {
        grid-column: auto; /* Reset column positioning */
      }
      .skill-item {
        padding: 15px;
      }
      .skill-icon {
        font-size: 24px;
      }
      .skill-text {
        font-size: 13px;
      }
    }
  `}
      </style>
    </div>
  );
};

export default SkilledUniversities;
